import { API_endpoints } from "../config"; 

export const checkSession = async () => {
    try {
        const response = await fetch(API_endpoints.checkSession, {
            method: 'Post',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({}),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message ||"Fehler beim session checken.");
        }
        const SessionData = await response.json();
        return SessionData; 
    } catch (error) {
        console.error("Fehler beim session checken:", error);
        throw error; 
    }
};